import packageJson from "../../package.json";
import Base64Helper from "../services/helpers/Base64Helper";
import { Browser } from "../services/helpers/Browser";
export const RE_CAPTCHA_KEY = "6LfP5mwUAAAAADFR3Xq5-vv4S9UvswTgS8YfdffI";

export const APP_VERSION = packageJson.version;
export const CACHE_VERSION = packageJson['cache-version'];
export const DEFAULT_PARTNER = 2121;

const SiteTmplate = {
  Classic: 1,
};

/**
 * Global variable template id
 */
export const template = window.template || SiteTmplate.Classic;

const siteDomain = Browser.getDomain(false, true);
const config = {
  ENV: process.env.REACT_APP_ENV,
  BASE_DOMAIN: process.env.REACT_APP_BASE_DOMAIN,
  //Shame on me for this 
  WS_DOMAIN: Base64Helper.encode(Browser.getDomain()) ==='YmV0ZXJhLmJ5' ? Base64Helper.decode('c2l0ZWFwaS5iZXRlcmEuYnkvd2Vic29ja2V0Y3JlYXRl'): process.env.REACT_APP_WS_DOMAIN,

  BASE_URL: siteDomain === process.env.REACT_APP_BASE_DOMAIN ? process.env.REACT_APP_ALTERNATIVE_API_URL : process.env.REACT_APP_API_URL,
  DEFAULT_SITE_URL: process.env.REACT_APP_VERSION === "no_version" ? process.env.REACT_APP_DEFAULT_SITE_URL : process.env.REACT_APP_DEFAULT_SITE_URL + APP_VERSION,
  CDN_URL: process.env.REACT_APP_CDN_URL,
  IMAGES_CDN_URL: process.env.REACT_APP_IMAGES_CDN_URL ? process.env.REACT_APP_IMAGES_CDN_URL : Browser.getOriginDomain(),
  NEW_PLAT: process.env.REACT_APP_NEW_PLAT === 'true',
  REMOTE_LOCAL_STORAGE_URL: process.env.REACT_APP_REMOTE_LOCAL_STORAGE_URL,
  REACT_APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  REACT_APP_HEADER_CONTENT_TYPE: process.env.REACT_APP_HEADER_CONTENT_TYPE,
  IS_AFFILIATE: process.env.REACT_APP_IS_AFFILIATE === 'true',
  PLAYER_DATA_CALL_INTERVAL: process.env.REACT_APP_PLAYER_DATA_CALL_INTERVAL || 30000,
  PAYMENT_SCRIPT_URL:  process.env.REACT_APP_PAYMENT_SCRIPT_URL,
  PAYMENT_BARCODE_URL: process.env.REACT_APP_PAYMENT_BARCODE_URL,
  RELUM_WIDGET_SCRIPT_URL: process.env.REACT_APP_RELUM_WIDGET_SCRIPT_URL,
  SPORT_NEW_ROUTING: process.env.REACT_APP_SPORT_NEW_ROUTING,
  VERTICAL_VIEW: process.env.REACT_APP_VERTICAL_VIEW,
  SPORT_NEW_ROUTING_ENABLED: process.env.REACT_APP_SPORT_NEW_ROUTING_ENABLED === 'true',
  CYPROS_DOCTYPE: process.env.REACT_APP_CYPROS_DOCTYPE,
  GREECE_DOCTYPE: process.env.REACT_APP_GREECE_DOCTYPE,
  GREECE_DOCTYPE_COUNT: process.env.REACT_APP_GREECE_DOCTYPE_COUNT,
  APP_VERSION,
  CACHE_VERSION
};

const domainMatch = window.location.hostname.match(/([a-z0-9-]*?)\.[a-z]{2,}$/);
const domain = domainMatch && domainMatch[0];
export const postMessageWhiteList = [domain, "http://localhost:3000", "admindigi.com"];

export default config;
